(function (window, $j, angular) {
  "use strict";
  if ($j(".icon-container").children().length < 1) {
    $j(".icon-container").addClass("icon-separator");
  }
  if ($j(".overlay-content").length < 1) {
    $j(".overlay-content-container").hide();
  }
  $j(".page-title").flowtype({
    minimum: 320,
    maximum: 1200,
    minFont: 12,
    maxFont: 21,
    fontRatio: 30
  });

  var heroImageLink = $j(".hero > .hero-image").attr("data-link-url");

  if (typeof heroImageLink !== typeof undefined && heroImageLink !== false && heroImageLink !== "") {
    $j(".hero > .hero-image").css("cursor", "pointer");
  }
  $j(".hero > .hero-image").on("click", function (e) {
    if (heroImageLink.length > 0 && ($j(e.target).attr("class") === "hero-image" || $j(e.target).attr("class") === "container cta-container")) {
      window.open(heroImageLink, "_self");
    }
  });

  // Toggle controls, allow on mobile
  angular.element(window).bind('resize', function() {
    _toggleHeroIframeControlsOnResize();
  });
  _toggleHeroIframeControlsOnResize();

  function _enableIframeControls(controlsUrlSegment, iframe, iframeSrc) {
    iframe.attr('src', iframeSrc + controlsUrlSegment);
    iframe.css('pointer-events', 'auto');
  }

  function _disableIframeControls(controlsUrlSegment, iframe, iframeSrc) {
    iframeSrc.attr('src', iframeSrc.replace(controlsUrlSegment, ''));
    iframeSrc.css('pointer-events', 'none');
  }

  function _toggleHeroIframeControlsOnResize() {
    var controlsUrlSegment = '#controls';
    var heroIframe = $j('.hero .media iframe');
    var heroIframeSrc = heroIframe.attr('src');

    if (heroIframeSrc) {
      var hasControls = heroIframeSrc.indexOf(controlsUrlSegment) >= 0;

      if (screen.width <= 768 && !hasControls) {
        _enableIframeControls(controlsUrlSegment, heroIframe, heroIframeSrc);
      }

      if (screen.width > 768 && hasControls) {
        _disableIframeControls(controlsUrlSegment, heroIframe, heroIframeSrc);
      }
    }
  }
})(window, $j, angular);